export default "/images/zoom-in.svg?0bd438a75f4b1c762f10b224b510eb4f";